import PropTypes from 'prop-types'

import styles from './InputField.module.css'

export const InputField = ({
  label,
  name,
  type = 'text',
  value,
  checked,
  onChange,
  onBlur,
  placeholder,
  error,
  helperText,
  disabled = false,
  ...rest
}) => {
  const isSelectable = type === 'radio' || type === 'checkbox'
  const valueProps = isSelectable ? { value, checked } : { value: value ?? '' }

  return (
    <div className={`${styles.inputContainer} ${isSelectable ? styles.inputContainerRow : ''}`}>
      {label && <label htmlFor={name}>{label}</label>}

      <input
        name={name}
        type={type}
        {...valueProps}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        className={`${styles.input} ${error ? styles.inputError : ''}`}
        {...rest}
      />

      {(error || helperText) && (
        <span className={error ? styles.errorText : styles.helperText}>{error || helperText}</span>
      )}
    </div>
  )
}

InputField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool
}
